// Note:
// Currently, heap.track calls cannot be named click, change, submit as it clashes with internal variables.
// https://developers.heap.io/reference/track
export enum HeapCustomEventType {
  Dialog = 'Dialog',
  NotificationBellNewNotificationsAvailable = 'NotificationBellNewNotificationsAvailable',
  NotificationBellOpened = 'NotificationBellOpened',
  SocialConnectError = 'Social Connect Error',
  SocialConnected = 'Social Connected',
  SubscriptionCheckout = 'Subscription Checkout Success',
  WelcomeModalTest = 'Welcome Modal Test Viewed',
}

export type HeapEventProperties = Record<string, unknown>;
